module.exports = __webpack_public_path__ + "static/media/settingSvg.57a5cb65.svg";